import styled from 'styled-components';

export const TabRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #e2e2e2;
  margin-bottom: 1.5rem;
`;

export const Tab = styled.button<{ $active: boolean }>`
  background: none;
  border: none;
  padding: 0.6rem 1rem;
  font-family: 'RedHatDisplay-Bold';
  font-size: 0.95rem;
  cursor: pointer;
  color: ${props => (props.$active ? '#323232' : '#888888')};
  border-bottom: 2.5px solid
    ${props => (props.$active ? '#FF9800' : 'transparent')};
  margin-bottom: -1px;
  transition:
    color 0.2s,
    border-color 0.2s;

  &:hover {
    color: #323232;
  }
`;

export const DownloadLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.9rem;
  color: #1e88e1;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const BatchActionsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 0.8rem;
`;

export const AddMediaButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  border: 1px solid #e2e2e2;
  border-radius: 0.5rem;
  background: #fff;
  padding: 0.5rem 1rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.9rem;
  color: #323232;
  cursor: pointer;
  transition: border-color 0.2s;

  &:hover {
    border-color: #ff9800;
  }
`;

export const FormRow = styled.div`
  width: 100%;
  display: flex;
  gap: 0.7rem;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`;

export const FieldGroup = styled.div<{ $flex?: number }>`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  flex: ${props => props.$flex ?? 1};
  min-width: 0;
`;

export const FieldLabelRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FieldLabel = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.82rem;
  color: #555;
`;

export const FieldHint = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.78rem;
  color: #ff2e3e;
`;

export const PlainInput = styled.input`
  width: 100%;
  height: 3.05rem;
  border: 0.5px solid #e2e2e2;
  border-radius: 0.56rem;
  padding: 0 0.8rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: 1rem;
  color: #323232;
  background: #fff;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;

  &:focus {
    border-color: #ff9800;
  }

  &::placeholder {
    color: #aaa;
  }
`;

export const SelectBox = styled.select`
  width: 100%;
  height: 3.05rem;
  border: 0.5px solid #e2e2e2;
  border-radius: 0.56rem;
  padding: 0 0.8rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: 1rem;
  color: #323232;
  background: #fff;
  outline: none;
  cursor: pointer;
  transition: border-color 0.2s;

  &:focus {
    border-color: #ff9800;
  }
`;

export const SelectedChipBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 3.05rem;
  border: 0.5px solid #e2e2e2;
  border-radius: 0.56rem;
  padding: 0 0.8rem;
  background: #fff;
  gap: 0.5rem;
  box-sizing: border-box;
`;

export const SelectedChipText = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: 1rem;
  color: #323232;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ClearChipButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888;
  flex-shrink: 0;
  transition: color 0.2s;

  &:hover {
    color: #ff2e3e;
  }
`;

export const AlunosRow = styled.div`
  display: flex;
  min-height: 3.05rem;
  flex-direction: column;
  gap: 0.8rem;
  align-items: flex-start;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`;

export const StudentInputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 3.05rem;
  border: 0.5px solid #e2e2e2;
  border-radius: 0.56rem;
  background: #fff;
  overflow: hidden;
  min-width: 160px;
  flex-shrink: 0;
`;

export const StudentInput = styled.input`
  flex: 1;
  height: 100%;
  border: none;
  outline: none;
  padding: 0 0.8rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.95rem;
  color: #323232;
  background: transparent;

  &::placeholder {
    color: #aaa;
  }
`;

export const StudentInputArrow = styled.button`
  height: 100%;
  width: 2.4rem;
  border: none;
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1e88e1;
  flex-shrink: 0;
  transition: background 0.2s;

  &:hover {
    background: rgba(30, 136, 229, 0.06);
  }
`;

export const ChipsRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const StudentChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: #fff;
  border: 1px solid #d0e8ff;
  border-radius: 2rem;
  padding: 0.3rem 0.75rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.85rem;
  color: #323232;
  height: 3.05rem;
`;

export const ChipRemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  color: #888;
  line-height: 1;
  transition: color 0.2s;

  &:hover {
    color: #ff2e3e;
  }
`;

export const SaveRowButton = styled.button`
  align-self: flex-end;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: #ff9800;
  border: none;
  border-radius: 0.56rem;
  padding: 0 1.4rem;
  height: 3.05rem;
  font-family: 'RedHatDisplay-Bold';
  font-size: 0.95rem;
  color: #fff;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;

  &:hover {
    background: #e68900;
  }

  &:disabled {
    background: #f5c87a;
    cursor: not-allowed;
  }
`;

export const SecondaryRowButton = styled.button`
  align-self: flex-end;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: #fff;
  border: 1px solid #cfcfcf;
  border-radius: 0.56rem;
  padding: 0 1.2rem;
  height: 3.05rem;
  font-family: 'RedHatDisplay-Bold';
  font-size: 0.95rem;
  color: #555;
  cursor: pointer;
  white-space: nowrap;
  transition:
    border-color 0.2s,
    color 0.2s,
    background 0.2s;

  &:hover {
    border-color: #a8a8a8;
    color: #323232;
    background: #fafafa;
  }

  &:disabled {
    color: #a8a8a8;
    border-color: #e0e0e0;
    background: #f8f8f8;
    cursor: not-allowed;
  }
`;

export const TeamsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 1.5rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.82rem;

  th {
    background: #f5f5f5;
    color: #555;
    text-align: left;
    padding: 0.6rem 0.8rem;
    font-weight: 600;
    border-bottom: 1px solid #e2e2e2;
  }

  td {
    padding: 0.55rem 0.8rem;
    color: #323232;
    border-bottom: 1px solid #f0f0f0;
  }

  tr:last-child td {
    border-bottom: none;
  }

  tr:hover td {
    background: #fafafa;
  }
`;
